import { Injectable, OnDestroy } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";

import { AuthService } from "../services/auth.service";
import navRoutes, { isOnlyPermission } from "../components/common-sidebar/nav-routes";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate,OnDestroy {
  shipyardUrl:string="/inventory/skus";
  priceyardUrl:string="/priceyard/pricing-list";
  yardenerUrl:string="/planyard/purchasing";
  settingUrl:string="/settings/billing";
  integrationUrl:string="/settings/integrations"
  private destroy$ = new Subject<void>();
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authService.isLoggedIn()) {
      var user = this.authService.getUserInfo();
      if (state.url !== this.settingUrl) {
        this.authService.openPaymentDialog();
      }
      if (state.url !== this.integrationUrl) {
        this.authService.openActivateAccountPopup();
      }

      const url = navRoutes.find(route => {
        return route.url[0] === next.url[0].path;
      })

      if (next.url[0].path === 'forecasting' && user['isShipyard']) { 
        return true;
      }

      if (url) {
        if (url.permissions) {
          if (user[url.permissions]) {
            return true;
          } else {
            this.authService.redirectRouteOnLoad(user)
            return false;
          }
        } else if (url.excludeIfOnly) {
          if (isOnlyPermission(user, url.excludeIfOnly)) {
            this.authService.redirectRouteOnLoad(user)
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      this.router.navigate(["/account/login"]);
      return false;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}

